// memorii アプリ本体（lib/9.type/character.dart）のキャラクターデータを移植。
// 画像は public/personality/mbti/introduce/ 配下（WebP・軽量化済み）を参照。
// 長文の性格解説（personality/strong/business/point）は
// 「性格診断 改正案」シートの16タイプ本番コンテンツに置き換わったため廃止。
// 詳細は ./typeTabContent.ts を参照。

export type Character = {
  imagePath: string;
  heroPath: string;
  title: string;
  subtitle: string;
  color: string;
  catchphrase: string;
};

const asset = (path: string) => `/personality/${path}`;

export const typeGroupColors: Record<string, string> = {
  HS: '#146DC1', // 専門性×安定：ブルー
  HR: '#821FC8', // 専門性×挑戦：パープル
  CS: '#126F4C', // 関係性×安定：グリーン
  CR: '#DB2DBB', // 関係性×挑戦：ピンク
};

export function typeGroupColor(typeCode: string): string {
  const key = typeCode.length >= 2 ? typeCode.slice(0, 2) : '';
  return typeGroupColors[key] ?? '#CCCCCC';
}

export const characterInfo: Character[] = [
  {
    imagePath: asset('mbti/introduce/1.webp'),
    heroPath: asset('mbti/introduce/1_detail.webp'),
    title: 'CSEJ',
    subtitle: '信頼を築く推進者',
    color: '#C5CFD3',
    catchphrase: '人との関係を大切にしながら、自分から物事を前に進める人',
  },
  {
    imagePath: asset('mbti/introduce/2.webp'),
    heroPath: asset('mbti/introduce/2_detail.webp'),
    title: 'CSEP',
    subtitle: '自然体のコミュニケーター',
    color: '#FFE3B3',
    catchphrase: '自分らしい距離感で、人との関係を自然に作れる人',
  },
  {
    imagePath: asset('mbti/introduce/3.webp'),
    heroPath: asset('mbti/introduce/3_detail.webp'),
    title: 'CSTJ',
    subtitle: '安心と信頼の伴走者',
    color: '#C5CFD3',
    catchphrase: '人との関係を、丁寧に長く育てていく人',
  },
  {
    imagePath: asset('mbti/introduce/4.webp'),
    heroPath: asset('mbti/introduce/4_detail.webp'),
    title: 'CSTP',
    subtitle: '安心感のムードメーカー',
    color: '#C5CFD3',
    catchphrase: '相手に自然に合わせながら、場を居心地よくする人',
  },
  {
    imagePath: asset('mbti/introduce/5.webp'),
    heroPath: asset('mbti/introduce/5_detail.webp'),
    title: 'CREJ',
    subtitle: '共感のプロデューサー',
    color: '#B0CAE7',
    catchphrase: '相手を理解し、次の一手を考えて形にする人',
  },
  {
    imagePath: asset('mbti/introduce/6.webp'),
    heroPath: asset('mbti/introduce/6_detail.webp'),
    title: 'CREP',
    subtitle: '直感の冒険家',
    color: '#B0CAE7',
    catchphrase: '人やチャンスを感じたら、自分から動いていける人',
  },
  {
    imagePath: asset('mbti/introduce/7.webp'),
    heroPath: asset('mbti/introduce/7_detail.webp'),
    title: 'CRTJ',
    subtitle: '変化のナビゲーター',
    color: '#B0CAE7',
    catchphrase: '周りと一緒に、新しい方向へ進んでいける人',
  },
  {
    imagePath: asset('mbti/introduce/8.webp'),
    heroPath: asset('mbti/introduce/8_detail.webp'),
    title: 'CRTP',
    subtitle: '即興パフォーマー',
    color: '#B0CAE7',
    catchphrase: 'その場の空気を読み、瞬時に動ける人',
  },
  {
    imagePath: asset('mbti/introduce/9.webp'),
    heroPath: asset('mbti/introduce/9_detail.webp'),
    title: 'HSEJ',
    subtitle: '自走する技術探究者',
    color: '#A8CEB6',
    catchphrase: '自分で課題を見つけ、計画的に技術を磨いていく人',
  },
  {
    imagePath: asset('mbti/introduce/10.webp'),
    heroPath: asset('mbti/introduce/10_detail.webp'),
    title: 'HSEP',
    subtitle: '自分流を磨く職人',
    color: '#A8CEB6',
    catchphrase: '自分らしいやり方で、じっくり技術を深めていく人',
  },
  {
    imagePath: asset('mbti/introduce/11.webp'),
    heroPath: asset('mbti/introduce/11_detail.webp'),
    title: 'HSTJ',
    subtitle: '技術を積み上げる職人',
    color: '#A8CEB6',
    catchphrase: '教わったことを着実に吸収し、確かな技術へ変えていく人',
  },
  {
    imagePath: asset('mbti/introduce/12.webp'),
    heroPath: asset('mbti/introduce/12_detail.webp'),
    title: 'HSTP',
    subtitle: 'しなやかな技術職人',
    color: '#A8CEB6',
    catchphrase: '基本を大切にしながら、現場では柔軟に対応できる人',
  },
  {
    imagePath: asset('mbti/introduce/13.webp'),
    heroPath: asset('mbti/introduce/13_detail.webp'),
    title: 'HREJ',
    subtitle: '未来を形にする技術開拓者',
    color: '#D0CAE8',
    catchphrase: '新しい技術を自分で見つけ、計画して形にする人',
  },
  {
    imagePath: asset('mbti/introduce/14.webp'),
    heroPath: asset('mbti/introduce/14_detail.webp'),
    title: 'HREP',
    subtitle: '自由発想のクリエイター',
    color: '#D0CAE8',
    catchphrase: '自分らしい発想を、技術と表現に変えていく人',
  },
  {
    imagePath: asset('mbti/introduce/15.webp'),
    heroPath: asset('mbti/introduce/15_detail.webp'),
    title: 'HRTJ',
    subtitle: '技術のパイオニア',
    color: '#D0CAE8',
    catchphrase: '新しい技術を学び、確かな武器へ変えていく人',
  },
  {
    imagePath: asset('mbti/introduce/16.webp'),
    heroPath: asset('mbti/introduce/16_detail.webp'),
    title: 'HRTP',
    subtitle: 'ひらめきのチャレンジャー',
    color: '#D0CAE8',
    catchphrase: '気になった技術は、まず試して経験から吸収する人',
  },
];

export function findCharacter(type: string): Character | undefined {
  return characterInfo.find((c) => c.title === type);
}

export const questionPlaceholderImage = asset('mbti/question.webp');

export const mbtiTagMap: Record<string, string[]> = {
  CSEJ: ['営業中の練習OK', '奨学金返済サポートあり', '時短勤務可'],
  CSEP: ['SNS研修あり', 'セミナー参加費補助', '配属店舗の選択可'],
  CSTJ: ['自社アカデミーあり', '資格取得支援', 'ボーナス支給実績あり'],
  CSTP: ['複数の教育体制から選択可', '20時までに退勤可能', '残業月20時間以内'],
  CREJ: ['海外研修あり', 'SNS研修あり', 'セミナー参加費補助'],
  CREP: ['海外研修あり', '動画研修制度あり', '複数のキャリアプランを選択可'],
  CRTJ: ['社内コンテストあり', '自社アカデミーあり', 'ボーナス支給実績あり'],
  CRTP: ['動画研修制度あり', '海外研修あり', '複数の教育体制から選択可'],
  HSEJ: ['営業中の練習OK', '残業月20時間以内', '社会保険完備'],
  HSEP: ['ウィッグ代補助', '配属店舗の選択可', '20時までに退勤可能'],
  HSTJ: ['資格取得支援', '社内コンテストあり', '自社アカデミーあり'],
  HSTP: ['年間休日120日以上', '車・バイク出勤可', '20時までに退勤可能'],
  HREJ: ['自社アカデミーあり', 'セミナー参加費補助', '資格取得支援'],
  HREP: ['海外研修あり', '動画研修制度あり', 'ウィッグ代補助'],
  HRTJ: ['資格取得支援', '自社アカデミーあり', 'ボーナス支給実績あり'],
  HRTP: ['海外研修あり', '複数のキャリアプランを選択可', '動画研修制度あり'],
};
